<template>
  <!--注册红包-->
  <RegisterBonusDialog v-if="isHome" />

  <!--红包雨-->
  <RedPacketsRain v-if="isHome" />

  <!--首充奖励-->
  <DepositBonus v-if="isHome" />

  <!--每日签到-->
  <DailySignIn v-if="isHome" />

  <!--幸运大转盘-->
  <LotteryWheel v-if="isHome" />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

const RegisterBonusDialog = defineAsyncComponent(() => import('@/pages/activity/activity/registerBonus/dialog.vue'));
const RedPacketsRain = defineAsyncComponent(() => import('@/pages/activity/activity/RedPacketsRain/index.vue'));
const DepositBonus = defineAsyncComponent(() => import('@/components/modal/activity/DepositBonus.vue'));
const DailySignIn = defineAsyncComponent(() => import('@/components/modal/activity/DailySignIn.vue'));
const LotteryWheel = defineAsyncComponent(() => import('@/components/modal/activity/LotteryWheel.vue'));

const uRoute = useRoute();

const isHome = computed(() => {
  return uRoute.name === 'home';
});
</script>

<style scoped lang="less"></style>
